import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

type UserDefaultConfirmationModalProps = {
	readonly onClose: () => void;
	readonly onConfirm: () => void;
	readonly type: "Pickup" | "Delivery";
};

export function UserDefaultConfirmationModal({
	onClose,
	onConfirm,
	type,
}: UserDefaultConfirmationModalProps) {
	return (
		<TraxModal
			onCancel={onClose}
			onClose={onClose}
			onConfirm={onConfirm}
			title={`Change ${type} User Default`}
			type={"confirmation"}
		>
			<p>
				You already have a {type.toLowerCase()} user default. Would you like to
				replace it with this address?
			</p>
		</TraxModal>
	);
}
